module.exports = __webpack_public_path__ + "static/media/ic_add.2e057164.svg";